import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Clock, AlertTriangle } from 'lucide-react';

/**
 * Modal warning users about imminent auto-logout due to inactivity.
 */
export const InactivityWarningModal = ({ open, onStayLoggedIn, remainingSeconds }) => {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${seconds.toString().padStart(2, '0')}`
    : `${seconds} seconds`;

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md bg-slate-900 border-yellow-500/50 text-white">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-yellow-400">
            <AlertTriangle className="h-5 w-5" />
            Session Timeout Warning
          </DialogTitle>
          <DialogDescription className="text-gray-300">
            You've been inactive for a while. For your security, you'll be
            automatically signed out soon.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center py-6 space-y-4">
          <div className="flex items-center gap-2 text-3xl font-mono text-yellow-400">
            <Clock className="h-8 w-8" />
            <span>{timeDisplay}</span>
          </div>
          <p className="text-sm text-gray-400 text-center">
            Click the button below to stay signed in and continue your investigation.
          </p>
        </div>

        <div className="flex justify-center">
          <Button
            onClick={onStayLoggedIn}
            className="bg-yellow-600 hover:bg-yellow-500 text-white font-semibold px-8 py-2"
          >
            Stay Signed In
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
